import { render, staticRenderFns } from "./empresa-sistema.vue?vue&type=template&id=2532eae9&"
import script from "./empresa-sistema.vue?vue&type=script&lang=js&"
export * from "./empresa-sistema.vue?vue&type=script&lang=js&"
import style0 from "./empresa-sistema.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports